/**
 * Pick the first printable character from a list of candidates, preferring
 * earlier entries. Uses `||`-style fallthrough (not `??`) so empty and
 * whitespace-only strings are skipped — otherwise an account with
 * `displayName === ""` would render a blank avatar circle instead of
 * falling through to email.
 */
export function firstInitial(...candidates: readonly (string | undefined | null)[]): string {
  for (const value of candidates) {
    const trimmed = value?.trim();
    if (trimmed) return trimmed.charAt(0).toUpperCase();
  }
  return "?";
}
